// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"574fe3bf","339":"74e5748e","551":"f08f88f6","588":"743e6a23","640":"11126420"}[chunkId] + ".chunk.js";
};